// @flow
import React from 'react'
import styled from 'styled-components'

const StyledMindBlown = styled.svg`
  padding: 58px 0;
`

const MindBlown = () => {
  return (
    <StyledMindBlown
      width="64"
      height="64"
      fill="none"
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#A5C5C7"
        d="M32 2a30 30 0 1 0 30 30A30.034 30.034 0 0 0 32 2zm2.621 11l-1.31 26.862H30.69L29.379 13h5.242zM32 51a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
      />
    </StyledMindBlown>
  )
}

export default MindBlown



// WEBPACK FOOTER //
// ./src/components/Icons/MindBlown.js